import { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function googleLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

const Divider = () => (
  <div className="flex items-center gap-4 my-6 text-[11px] uppercase tracking-[0.2em] muted">
    <span className="h-px flex-1 bg-[#F0EAF7]" />or<span className="h-px flex-1 bg-[#F0EAF7]" />
  </div>
);

const GoogleBtn = () => (
  <button type="button" onClick={googleLogin} className="btn-secondary w-full" data-testid="google-login-button">
    <svg width="16" height="16" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>
    Continue with Google
  </button>
);

function useAuthForm(endpoint, to) {
  const { signIn } = useAuth();
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e, payload) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post(endpoint, payload);
      signIn(data, to);
    } catch (err) {
      setError(formatErr(err));
    } finally { setBusy(false); }
  };
  return { error, busy, submit };
}

const Err = ({ msg }) => msg ? <p className="text-sm text-red-400 mb-4" data-testid="auth-error-message">{msg}</p> : null;

export function Login() {
  const [f, setF] = useState({ email: "", password: "" });
  const { error, busy, submit } = useAuthForm("/auth/login", "/");
  return (
    <AuthShell eyebrow="Welcome back" title="Sign in" subtitle="Return to your studio and your muses.">
      <form onSubmit={(e) => submit(e, f)} className="space-y-5">
        <div><label className="label">Email</label>
          <input className="field" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="you@studio.com" data-testid="login-email-input" /></div>
        <div><label className="label">Password</label>
          <input className="field" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="••••••••" data-testid="login-password-input" /></div>
        <div className="text-right -mt-2"><Link to="/forgot-password" className="text-xs text-[#9C4DDC] hover:underline" data-testid="login-forgot-password-link">Forgot password?</Link></div>
        <Err msg={error} />
        <button className="btn-primary w-full" disabled={busy} data-testid="login-submit-button">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
      <Divider /><GoogleBtn />
      <p className="text-sm muted mt-8">New here? <Link to="/signup" className="text-[#9C4DDC]" data-testid="login-register-link">Create an account</Link></p>
    </AuthShell>
  );
}

export function Signup() {
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const { error, busy, submit } = useAuthForm("/auth/register", "/muses/new");
  return (
    <AuthShell eyebrow="Begin" title="Open your studio" subtitle="Build a muse bible that keeps her identical in every prompt.">
      <form onSubmit={(e) => submit(e, f)} className="space-y-5">
        <div><label className="label">Your name</label>
          <input className="field" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Jordan" data-testid="signup-name-input" /></div>
        <div><label className="label">Email</label>
          <input className="field" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="you@studio.com" data-testid="signup-email-input" /></div>
        <div><label className="label">Password</label>
          <input className="field" type="password" required minLength={6} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="At least 6 characters" data-testid="signup-password-input" /></div>
        <Err msg={error} />
        <button className="btn-primary w-full" disabled={busy} data-testid="signup-submit-button">{busy ? "Creating…" : "Create account"}</button>
      </form>
      <Divider /><GoogleBtn />
      <p className="text-sm muted mt-8">Already a member? <Link to="/login" className="text-[#9C4DDC]" data-testid="signup-login-link">Sign in</Link></p>
    </AuthShell>
  );
}
